import { useParams } from 'react-router-dom';

import { useGetChronology } from '@/api/queries/useGetChronology';
import { ChronologyFactDropdown } from '@/new/components/fact/chronology-fact-accordion';
import { Icon } from '@/new/components/icon';
import { Accordion } from '@/new/components/shadcn/accordion';
import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@/new/components/shadcn/empty';
import { ChronologyFact } from '@/types';

interface TableTimelineProps {
  chronologyFacts: ChronologyFact[];
  onViewDocument: (docId: string, factId: string) => void;
}

export function TableTimeline({ chronologyFacts, onViewDocument }: TableTimelineProps) {
  const { subsetId, chronologyId } = useParams();
  if (!subsetId || !chronologyId) return null;

  const { data: chronology } = useGetChronology({
    chronologyId,
    caseId: subsetId,
  });

  return (
    <div className="h-full">
      {!chronology || chronologyFacts.length === 0 ? (
        <div className="flex w-full items-center justify-center py-6">
          <Empty>
            <EmptyHeader>
              <EmptyMedia variant="icon">
                <Icon className="lucide--git-fork h-6 w-6" />
              </EmptyMedia>
              <EmptyTitle>No chronology facts found</EmptyTitle>
              <EmptyDescription>This chronology does not contain any facts.</EmptyDescription>
            </EmptyHeader>
          </Empty>
        </div>
      ) : (
        <Accordion type="multiple" className="flex h-full flex-col gap-3 pr-1 pl-3">
          {chronologyFacts.map((chronologyFact) => (
            <div key={chronologyFact.id} className="group relative flex w-full items-center gap-2.5 pl-10">
              <div className="absolute left-0.25 z-10 h-4 w-4 rounded-full border-2 border-teal-500 bg-white" />
              <div className="absolute inset-0 -inset-y-3 w-0.5 translate-x-[8px] bg-gray-200 group-first:top-1/2 group-last:bottom-1/2"></div>

              <ChronologyFactDropdown
                fact={chronologyFact}
                onViewDocument={onViewDocument}
                subsetId={subsetId}
                chronology={chronology}
              />
            </div>
          ))}
        </Accordion>
      )}
    </div>
  );
}
